import { Auth } from "aws-amplify";

export const USER_GROUPS = {
    ADMIN: 'FWC_Admin',
    DATA_PROVIDER: 'Data_Provider',
    INDEPENDENCE_CHECKS: 'INDEPENDENCE_CHECKS',
    SALES: 'Sales',
    SURVEY: 'Survey',
    INTERNAL: 'Internal',
    CLIENT: 'Client',
    EXTERNAL: 'External'
};

export async function getAuthToken() {
    try {
        const currentSession = (await Auth.currentSession());
        return currentSession.getIdToken().getJwtToken();
    } catch (error) {
        await Auth.signOut({ global: true });
        // reload the page to get the user to the login page
        window.location.reload();
    }
}

export const checkUserGroup = async (groupName) => {
    try {
        const user = await Auth.currentAuthenticatedUser();
        const groups = user.signInUserSession.accessToken.payload["cognito:groups"];
        return groups.includes(groupName);
    } catch (error) {
        console.error('Error checking user group:', error);
        return false;
    }
};

export const getUserId = async () => {
    try {
        const user = await Auth.currentAuthenticatedUser();
        return user.signInUserSession.accessToken.payload.username;
    } catch (error) {
        console.error('Error getting user ID:', error);
        return null;
    }
};

export const checkIfCurrentUserIsAdmin = async () => {
    try {
        const user = await Auth.currentAuthenticatedUser();
        const groups = user.signInUserSession.accessToken.payload["cognito:groups"];
        return groups.includes(USER_GROUPS.ADMIN);
    } catch (error) {
        console.error('Error checking if user is admin:', error);
        return false;
    }
};